var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerateStrongPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86719 0.839844C10.4023 0.839844 13.2441 3.68164 13.2441 7.20703C13.2441 9.85352 11.623 12.0898 8.69336 13.3301L11.1152 15.7715C11.3887 16.0449 11.3887 16.4453 11.1348 16.6992L8.64453 19.1992L10.4219 20.957C10.6855 21.2305 10.6953 21.6211 10.4219 21.9043L7.3457 24.9805C7.08203 25.2441 6.67188 25.1953 6.4668 24.9902L4.77734 23.3398C4.5625 23.1348 4.47461 22.8906 4.47461 22.6074V13.125C2.0332 12.1582 0.490234 9.82422 0.490234 7.20703C0.490234 3.67188 3.32227 0.839844 6.86719 0.839844ZM6.86719 6.77734C7.81445 6.77734 8.58594 6.00586 8.58594 5.04883C8.58594 4.11133 7.81445 3.33008 6.86719 3.33008C5.91016 3.33008 5.14844 4.0918 5.14844 5.04883C5.14844 6.00586 5.91992 6.77734 6.86719 6.77734Z",
    fill: "#005BBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateStrongPassword);
export default __webpack_public_path__ + "static/media/generate_strong_password.4636d76ed380aab153b88e9d56e85d23.svg";
export { ForwardRef as ReactComponent };